import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: "",
  show: false,
  error: false,
  link: "",
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    success: (state, action) => {
      state.show = true;
      state.message = action.payload.message;
    },
    error: (state, action) => {
      state.error = true;
      state.message = action.payload;
    },
    closeNotification: (state) => {
      state.show = false;
    },
    closeErrorNotification: (state) => {
      state.error = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { success, closeNotification, error, closeErrorNotification } =
  notificationSlice.actions;
export const notificationSelector = (state) => state;

export default notificationSlice.reducer;
